import type { ClassesFormRequest, EventCalendar, LessonsInClass } from './type';

export const defaultClassesForm: ClassesFormRequest = {
  name: '',
  description: '',
  isActive: false,
  isCompleted: false,
  code: '',
  thumbnail: '',
  institution: '',
};

export const defaultLessonsInClass: LessonsInClass = {
  today: [],
  future: [],
  unscheduled: [],
  past: [],
  totalLearner: 0,
};

export const defaultEventCalendar: EventCalendar = {
  id: '',
  title: '',
  type: '',
  start: '',
  end: '',
  classLessonId: '',
  classScheduleId: '',
};
